<template>
  <RevList :has-external-borders="false">
    <RevListItemInteractive
      data-qa="tracking-numbers-import-button"
      @click="handleSelectListItem('tracking-numbers')"
    >
      <template #label>
        {{ i18n(translations.importTrackingNumbers) }}
      </template>
      <template #suffix>
        <IconChevronRight />
      </template>
    </RevListItemInteractive>

    <RevListItemInteractive
      data-qa="imei-import-button"
      @click="handleSelectListItem('imei-numbers')"
    >
      <template #label>{{ i18n(translations.importIMEIs) }}</template>
      <template #description>
        {{ i18n(translations.importIMEIsDescription) }}
      </template>
      <template #suffix>
        <IconChevronRight />
      </template>
    </RevListItemInteractive>
  </RevList>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevList } from '@ds/components/List'
import { RevListItemInteractive } from '@ds/components/ListItemInteractive'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import type { ListItem } from '../../ImportDrawer.types'

import translations from './List.translations'

const i18n = useI18n()

const emit = defineEmits(['select-list-item'])

function handleSelectListItem(listItem: ListItem) {
  emit('select-list-item', listItem)
}
</script>
